const environments = {
    prod: {
        domain: "https://api.feelhq.co.uk",
        STRIPE_KEY: "pk_live_51OjTBDCiu81PojATPordUgHzRkUQMsQY6nscmVnLDKEiyADt2lyZMi1AYaTwDtJxUEvKDVUuDJQQ49ssFL246cWB00YAjiHGX4"
    },
    dev: {
        domain: "https://edufeel-api.dextrouslab.com",
        STRIPE_KEY: "pk_test_51OjTBDCiu81PojATCx5EAEmts5KbZqBoSJ4N3h71XDm91c9BX5jENScq13Y3wyHLYUE27mwracq98FdezNHPZLEE00tYEkau5T"
    },
    local: {
        domain: "http://127.0.0.1:8000",
        STRIPE_KEY: "pk_test_51OjTBDCiu81PojATCx5EAEmts5KbZqBoSJ4N3h71XDm91c9BX5jENScq13Y3wyHLYUE27mwracq98FdezNHPZLEE00tYEkau5T"
    }
};

// Choose environment: 'prod', 'dev', or 'local'
const currentEnv = 'prod';

const { domain, STRIPE_KEY } = environments[currentEnv];

// Create URLs based on the domain
export const baseUrl = `${domain}/`;
export const mediaUrl = `${domain}/images/nurseries/`;
export const employeeMediaUrl = `${domain}/images/employee/`;
export const ticketMediaUrl = `${domain}/images/ticket`;
export const ticketResponseMediaUrl = `${domain}/images/ticket_response`;
export const reasonsIconURL = `${domain}/images/reasons/pdfImages`;
export { STRIPE_KEY };
export const googleApiKey = "AIzaSyCD-1oVkve0-GfHCIm8pJrSlfW-DwCrUC4"; 

